import { useEffect } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '@/stores/auth'
import { useSubscriptionStore } from '@/stores/subscription'

/** Route guard: redirects unauthenticated users to /login and loads session context. */
export function RequireAuth({ children }: { children: React.ReactNode }) {
  const location = useLocation()
  const sessionToken = useAuthStore((s) => s.sessionToken)
  const userDetails = useAuthStore((s) => s.userDetails)
  const fetchUserDetails = useAuthStore((s) => s.fetchUserDetails)
  const loadSubscription = useSubscriptionStore((s) => s.load)

  useEffect(() => {
    if (!sessionToken) return
    if (!userDetails) {
      fetchUserDetails().catch(() => {
        // A failed details call means the token is invalid; the API client's
        // 401 handling redirects to /login.
      })
    }
    void loadSubscription()
  }, [sessionToken, userDetails, fetchUserDetails, loadSubscription])

  if (!sessionToken) {
    const redirect = encodeURIComponent(location.pathname + location.search)
    return <Navigate to={`/login?redirect=${redirect}`} replace />
  }

  return <>{children}</>
}
